import React, { useEffect, useRef, useState } from "react";
import CoreInput from "../../core/inputs/CoreInput";
import { useDispatch, useSelector } from "react-redux";
import { api_request } from "../../store/actions/commonAction";
import {
  API_METHOD_POST,
  googleLoginEnabled,
  newUserEnabled,
} from "../../config/constants";
import {
  CHECK_USER_EXIST_ERROR,
  CHECK_USER_EXIST_LOADING,
  CHECK_USER_EXIST_SUCCESS,
  GOOGLE_LOGIN_ERROR,
  GOOGLE_LOGIN_LOADING,
  GOOGLE_LOGIN_SUCCESS,
  LOGIN_ERROR,
  LOGIN_SUCCESS,
  SET_AUTH_REDUCER,
} from "../../store/types/authTypes";
import { setAuthReducer } from "../../store/actions/authActions";
import { Box } from "@mui/material";
import AuthContainer from "./AuthContainer";
import CoreContainedButton from "../../core/inputs/CoreContainedButton";
import { GoogleLogin } from "@react-oauth/google";
import { theme } from "../../config/theme";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import { Formik } from "formik";
import { emailOrPhoneSchema, loginSchema } from "../../formSchemas/authSchemas";
import CoreCaptcha from "../../core/inputs/CoreCaptcha";
import CorePassword from "../../core/inputs/CorePassword";
import { useNavigate } from "react-router";
import { setNextUrl } from "../../store/actions/routeActions";

export default function SignIn() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const captchaRef = useRef();

  const authError = useSelector((state) => state?.auth?.authError);
  const verificationRequired = useSelector(
    (state) => state?.auth?.verificationRequired,
  );
  const appSettings = useSelector((state) => state?.common?.appSettings);

  const googleLogin = appSettings?.find(
    (set) => set.name === googleLoginEnabled,
  )
    ? appSettings?.find((set) => set.name === googleLoginEnabled)?.value
        ?.enabled
    : true;

  const newUser = appSettings?.find((set) => set.name === newUserEnabled)
    ? appSettings?.find((set) => set.name === newUserEnabled)?.value?.enabled
    : true;

  useEffect(() => {
    return () => {
      dispatch(setAuthReducer({ authError: null }));
    };
  }, []);

  useEffect(() => {
    if (verificationRequired) {
      navigate("/verify/account");
      dispatch(setNextUrl("/verify/account"));
    }
  }, [verificationRequired]);

  useEffect(() => {
    if (authError) {
      captchaRef?.current?.reset();
    }
  }, [authError]);

  const onSubmit = (values, actions) => {
    dispatch({
      type: SET_AUTH_REDUCER,
      payload: { email: values.email },
    });

    dispatch(
      api_request(
        API_METHOD_POST,
        "/login",
        {
          email: values.email,
          password: values.password,
          captchaToken: values.captchaToken,
        },
        {},
        null,
        LOGIN_SUCCESS,
        LOGIN_ERROR,
        false,
        false,
        false,
        true,
      ),
    );
  };

  const onGoogleLoginSuccess = (data) => {
    dispatch(
      api_request(
        API_METHOD_POST,
        "/login/google",
        {
          credential: data?.credential,
        },
        {},
        GOOGLE_LOGIN_LOADING,
        GOOGLE_LOGIN_SUCCESS,
        GOOGLE_LOGIN_ERROR,
        false,
        false,
      ),
    );
  };

  const onSignUp = () => {
    navigate("/signup");
    dispatch(setNextUrl("/signup"));
  };

  const onForgotPassword = () => {
    navigate("/reset/password");
    dispatch(setNextUrl("/reset/password"));
  };

  return (
    <AuthContainer showHeading={true}>
      <CoreH4
        style={{
          fontStyle: "italics",
          color: theme.palette.primary.main,
          alignSelf: "baseline",
        }}
      >
        Sign In
      </CoreH4>
      <form onSubmit={onSubmit} style={{ width: "100%" }}>
        {googleLogin ? (
          <>
            <Box style={{ marginTop: 16 }}>
              <GoogleLogin
                style={{ width: "100%" }}
                onSuccess={onGoogleLoginSuccess}
                onError={() => {
                  console.log("Login Failed");
                }}
                useOneTap
              />
            </Box>
            <p
              style={{
                textAlign: "center",
                marginTop: 16,
              }}
            >
              <span
                style={{
                  backgroundColor: theme.palette.background.paper,
                  paddingLeft: 16,
                  paddingRight: 16,
                }}
              >
                or
              </span>
            </p>
            <div
              style={{
                height: 2,
                backgroundColor: theme.palette.grey[300],
                marginTop: -24,
                marginBottom: 24,
              }}
            ></div>
          </>
        ) : (
          <Box style={{ padding: 8 }} />
        )}
        <Formik
          initialValues={{ email: "", password: "", captchaToken: "" }}
          validationSchema={loginSchema}
          onSubmit={onSubmit}
        >
          {(formikProps) => (
            <>
              <CoreInput
                id="email"
                onBlur={formikProps.handleBlur("email")}
                onChange={formikProps.handleChange("email")}
                value={formikProps.values.email}
                formikProps={formikProps}
                autoFocus={false}
                label="Enter email or phone"
                autoComplete="off"
                inputProps={{ "aria-autocomplete": "none" }}
              />
              <CorePassword
                id="password"
                onBlur={formikProps.handleBlur("password")}
                onChange={formikProps.handleChange("password")}
                value={formikProps.values.password}
                formikProps={formikProps}
                autoFocus={false}
                label="Enter password"
              />
              <CoreCaptcha
                id="captchaToken"
                onChange={(val) => {
                  if (val) {
                    formikProps.setFieldValue("captchaToken", val);
                  }
                }}
                formikProps={formikProps}
                captchaRef={captchaRef}
              />
              <Box
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <CoreContainedButton
                  type="submit"
                  fullWidth={true}
                  onClick={formikProps.handleSubmit}
                >
                  Continue
                </CoreContainedButton>
              </Box>
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                <CoreContainedButton variant="text" onClick={onForgotPassword}>
                  Forgot Password
                </CoreContainedButton>
              </Box>
            </>
          )}
        </Formik>
      </form>
    </AuthContainer>
  );
}
